__turbopack_context__.v({
  "inverseBackground45": "color-mix-fallbacks-module__kDDcNW__inverseBackground45",
  "inverseBorder22": "color-mix-fallbacks-module__kDDcNW__inverseBorder22",
  "inverseBorder35": "color-mix-fallbacks-module__kDDcNW__inverseBorder35",
  "inverseBorder45": "color-mix-fallbacks-module__kDDcNW__inverseBorder45",
  "inverseBorder70": "color-mix-fallbacks-module__kDDcNW__inverseBorder70",
  "inverseStroke28": "color-mix-fallbacks-module__kDDcNW__inverseStroke28",
  "inverseStroke45": "color-mix-fallbacks-module__kDDcNW__inverseStroke45",
  "loaderOuter": "color-mix-fallbacks-module__kDDcNW__loaderOuter",
  "mobileBackdrop": "color-mix-fallbacks-module__kDDcNW__mobileBackdrop",
  "mutedBackground35": "color-mix-fallbacks-module__kDDcNW__mutedBackground35",
  "mutedBorder60": "color-mix-fallbacks-module__kDDcNW__mutedBorder60",
  "mutedStroke35": "color-mix-fallbacks-module__kDDcNW__mutedStroke35",
  "mutedText60": "color-mix-fallbacks-module__kDDcNW__mutedText60",
  "navbarGlass": "color-mix-fallbacks-module__kDDcNW__navbarGlass",
});
